import http from '@/plugins/request'
//追踪查询
export const getCodeTrack = (params) => {
    return http.request({
        url: 'fch/dealer/pda/code/search',
        method: 'get',
        params
    })
}
